function makeSlotId(prop, formFieldId, propName) {
    if (!prop) {
        return undefined;
    }
    return formFieldId + "-" + propName;
}
export function getSlotIds(formFieldId, label, description, constraintText, errorText) {
    var ids = {
        label: makeSlotId(label, formFieldId, 'label'),
        description: makeSlotId(description, formFieldId, 'description'),
        constraint: makeSlotId(constraintText, formFieldId, 'constraint'),
        error: makeSlotId(errorText, formFieldId, 'error')
    };
    return ids;
}
export function getAriaDescribedBy(_a) {
    var error = _a.error, description = _a.description, constraint = _a.constraint;
    var describedByAttributes = [error, description, constraint].filter(function (e) { return !!e; });
    var describedBy = describedByAttributes.length ? describedByAttributes.join(' ') : undefined;
    return describedBy;
}
export function getGridDefinition(stretch, secondaryControlPresent) {
    var columns = stretch
        ? [{ colspan: 12 }, { colspan: 12 }]
        : [{ colspan: { "default": 12, xs: 9 } }, { colspan: { "default": 12, xs: 3 } }];
    if (!secondaryControlPresent) {
        return [columns[0]];
    }
    return columns;
}
// Joins strings with a whitespace, discarding empty strings
export var joinStrings = function () {
    var strings = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        strings[_i] = arguments[_i];
    }
    return strings.filter(function (val) { return val; }).join(' ');
};
//# sourceMappingURL=util.js.map